import type { RecapSection } from "@app/analytics/MeetingReport/types";
import type { TranscriptKeyword } from "@app/common/types";
import type { SSOProviderId } from "@app/common/types/providerTypes";
import { sendEvent } from "@app/utils/tracking/Tracker";

export const searchKeyword = sendEvent<{
  keyword: TranscriptKeyword["value"];
}>("search_keyword");

// Video interactions
export const playTrailer = sendEvent("play_trailer");
export const playVideo = sendEvent("play_video");
export const playHighlightReel = sendEvent<{ source: "switch" | "button" }>(
  "play_highlight_reel"
);
export const pauseHighlightReel = sendEvent<{ source: "switch" | "button" }>(
  "pause_highlight_reel"
);
export const playChapter = sendEvent<{ id: string; label: string }>(
  "play_chapter"
);
export const playNote = sendEvent("play_note");
export const playHighlight = sendEvent<{ type: string; id: string }>(
  "play_highlight"
);
export const playParticipantReel = sendEvent("play_participant_reel");

// Transcript
export const filterTranscriptBySpeakers = sendEvent(
  "filter_transcript_by_speakers"
);

// Editing
export const startEditing = sendEvent<{ section: RecapSection }>(
  "start_editing"
);
export const saveChanges = sendEvent("save_edit_changes");
export const editSpeaker = sendEvent<{ source: "tile" | "avatar" }>(
  "edit_speaker"
);
export const revertToOriginal = sendEvent<{ section: RecapSection }>(
  "revert_to_original"
);

// Misc
export const copyReportUrl = sendEvent("copy_report_url");
export const signUpReportClick = sendEvent<{
  provider: SSOProviderId | "email";
  source?: "transcript_upsell";
}>("sign_up_report_click");
export const shareToSlackClick = sendEvent("share_to_slack_click");
export const postedToSlack = sendEvent("post_to_slack_success");
